import { action } from 'satcheljs';

/**
 * Add a list of domains to the blocked senders list
 * @param domains domains to be added to blocked sender list
 */
export default action('ADD_DOMAINS_TO_BLOCKED_LIST', (domains: string[]) => ({
    domains,
}));
